/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PropsWithChildren } from "react";
import contentfulStandardApp, {
	fetchProps,
} from "@insightfulscience/contentful/Apps/Standard";
import SiteLayout from "@src/components/SiteLayout";
import { LocaleProvider } from "@insightfulscience/i18";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import WithErrorHandling from "@src/components/AppError/WithErrorHandling";
import TryForFree from "@src/components/TryForFree";
import { contentfulProps, publicConfig } from "@src/config";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import PreloadImages from "@src/components/PreloadImages";
import resources from "./locales";

const Layout = ({ children }: PropsWithChildren) => (
	<LocaleProvider resources={resources}>
		<SiteLayout>
			<PageMeta>
				<PreloadImages />
			</PageMeta>
			{children}
			<TryForFree />
		</SiteLayout>
	</LocaleProvider>
);

const ContentfulStandardApp = contentfulStandardApp({
	Layout,
	contentfulProps,
	pageProps: {
		resources,
		brandCode: "pm",
		siteDomain: publicConfig.CANONICAL_DOMAIN as string,
		preloadImages: true,
	},
	mode: "isr",
});

export const getStaticPaths = async () => {
	return {
		paths: [],
		fallback: "blocking",
	};
};

export const getStaticProps = async ({
	params: { slug },
}: {
	params: { slug: string[] };
}) => {
	const props: any = await fetchProps(contentfulProps, slug.join("/"), false);

	return props?.post
		? {
				props,
				revalidate: false,
			}
		: { notFound: true };
};

export default pipe(ContentfulStandardApp, WithErrorHandling as any);
